import messages from '../../../constants/messages'
import {
  SET_CAMPAIGNS,
  SET_FETCHING_CAMPAIGNS,
  SET_CLEAR_CAMPAIGNS,
  WERE_COOKIES_ACCEPTED,
  SET_TABPRODUCT,
  SET_MESSAGES,
  SET_FETCHING_MESSAGES,
  SET_CLEAR_MESSAGES,
} from '../../types/types'

const initialState = {
  campaigns: [],
  fetching: false,
  wereCookiesAccepted: false,
  selectedTab: localStorage.getItem('selectedProductTab') || "ET ADS",
  messages:[]
}
const campaingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CLEAR_CAMPAIGNS:
      return initialState
    case SET_CAMPAIGNS:
      return Object.assign({}, state, { campaigns: action.payload.campaigns })
    case SET_FETCHING_CAMPAIGNS:
      return Object.assign({}, state, { fetching: action.payload.fetching })
    case SET_TABPRODUCT:
      localStorage.setItem('selectedProductTab', action.payload.data);
      return { ...state, selectedTab: action.payload.data };
    case WERE_COOKIES_ACCEPTED:
        const updateWereCookiesAccepted = action.payload.data;
      return {...state, wereCookiesAccepted: updateWereCookiesAccepted}
      case SET_MESSAGES:
        return Object.assign({}, state, { messages: action.payload.messages })
      case SET_CLEAR_MESSAGES: 
        return {
          ...state,
          messages: initialState.messages,
          fetching: initialState.fetching,
        };
      case SET_FETCHING_MESSAGES:
        return Object.assign({}, state, { fetching: action.payload.fetching })
    default:
      return state
  }
}

export default campaingsReducer
